import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { isMobileBrowser } from '../../../environment/utils';
import Icon from '../../../icons/components/Icon';
import { IconCheck } from '../../../icons/svg';
import { withPixelLineHeight } from '../../../styles/functions.web';
const useStyles = makeStyles()(theme => {
    return {
        alignItemsStart: {
            alignItems: 'flex-start !important'
        },
        formControl: {
            ...withPixelLineHeight(theme.typography.bodyLongRegular),
            // color: theme.palette.default00,
            display: 'inline-flex',
            alignItems: 'center',
            width: 'fit-content',
            '&.is-mobile': {
                ...withPixelLineHeight(theme.typography.bodyLongRegularLarge)
            }
        },
        formControlFullWidth: {
            width: '100% !important'
        },
        disabled: {
            cursor: 'not-allowed',
            "&:hover": {
                backgroundColor: 'transparent !important'
            }
        },
        activeArea: {
            display: 'grid',
            placeContent: 'center',
            width: '36px',
            height: '36px',
            backgroundColor: 'transparent',
            marginRight: '2px',
            position: 'relative',
            cursor: 'pointer',
            borderRadius: '50%',
            minWidth: '36px',
            minHeight: '36px',
            '&:hover': {
                backgroundColor: theme.palette.backgroundTextHover,
                '&:has(input[type="checkbox"]:checked)': {
                    backgroundColor: theme.palette.primary10 + '10'
                }
            },
            '& input[type="checkbox"]': {
                appearance: 'none',
                backgroundColor: 'transparent',
                margin: '3px',
                font: 'inherit',
                color: theme.palette.icon03,
                width: '18px',
                height: '18px',
                border: `2px solid ${theme.palette.default00}`,
                borderRadius: '3px',
                display: 'grid',
                placeContent: 'center',
                '&::before': {
                    content: 'url("")',
                    width: '18px',
                    height: '18px',
                    opacity: 0,
                    backgroundColor: theme.palette.primary10,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: 0,
                    borderRadius: '3px',
                    transition: '.2s'
                },
                '&:checked::before': {
                    opacity: 1
                },
                '&:disabled': {
                    backgroundColor: theme.palette.white,
                    borderColor: theme.palette.disableCheckbox,
                    "&:hover": {
                        backgroundColor: theme.palette.white,
                    },
                    '&::before': {
                        backgroundColor: theme.palette.backgroundDisabled
                    }
                },
                '&:checked+.checkmark': {
                    opacity: 1
                }
            },
            '& .checkmark': {
                position: 'absolute',
                left: '9px',
                top: '9px',
                opacity: 0,
                transition: '.2s'
            },
            '&.is-mobile': {
                width: '40px',
                height: '40px',
                '& input[type="checkbox"]': {
                    width: '24px',
                    height: '24px',
                    '&::before': {
                        width: '24px',
                        height: '24px'
                    }
                },
                '& .checkmark': {
                    left: '11px',
                    top: '10px'
                }
            }
        }
    };
});
const Checkbox = ({ checked, className, disabled, label, name, onChange, styleLabelFullWidth = false, alignItemsStart = false }) => {
    const { classes: styles, cx, theme } = useStyles();
    const isMobile = isMobileBrowser();
    return (React.createElement("label", { className: cx(styles.formControl, isMobile && 'is-mobile', className, styleLabelFullWidth ? styles.formControlFullWidth : '', alignItemsStart ? styles.alignItemsStart : '') },
        React.createElement("div", { className: cx(styles.activeArea, isMobile && 'is-mobile', disabled && styles.disabled) },
            React.createElement("input", { checked: checked, disabled: disabled, name: name, onChange: onChange, type: 'checkbox' }),
            React.createElement(Icon, { "aria-hidden": true, className: 'checkmark', color: disabled ? theme.palette.disableSwitchButton : theme.palette.icon01, size: 18, src: IconCheck })),
        React.createElement("div", { style: { cursor: disabled ? 'default' : 'pointer', fontSize: '16px', width: styleLabelFullWidth ? '100%' : 'fit-content' } }, label)));
};
export default Checkbox;
